// src/components/ui/InstallPWA.jsx
// بانر تثبيت PWA — يظهر تلقائياً على Android
// وتعليمات يدوية على iOS (Safari لا يدعم الـ prompt التلقائي)
import { useState, useEffect } from "react";
import { T } from "./index";

export default function InstallPWA() {
    const [deferredPrompt, setDeferredPrompt] = useState(null);
    const [showBanner, setShowBanner] = useState(false);
    const [isIOS, setIsIOS] = useState(false);
    const [showIOSGuide, setShowIOSGuide] = useState(false);

    useEffect(() => {
        // تحقق من iOS
        const ios = /iPhone|iPad|iPod/i.test(navigator.userAgent) && !window.MSStream;
        setIsIOS(ios);

        // التطبيق مثبت بالفعل؟
        const isInstalled =
            window.matchMedia("(display-mode: standalone)").matches ||
            window.navigator.standalone === true;

        if (isInstalled) return;

        // سبق إغلاق البانر؟
        const dismissed = localStorage.getItem("pwa-banner-dismissed");
        if (dismissed) return;

        if (ios) {
            // iOS: نعرض البانر اليدوي بعد 3 ثواني
            setTimeout(() => setShowBanner(true), 3000);
        } else {
            // Android/Chrome: نستمع لـ beforeinstallprompt
            const handler = e => {
                e.preventDefault();
                setDeferredPrompt(e);
                setShowBanner(true);
            };
            window.addEventListener("beforeinstallprompt", handler);
            return () => window.removeEventListener("beforeinstallprompt", handler);
        }
    }, []);

    const handleInstall = async () => {
        if (!deferredPrompt) return;
        deferredPrompt.prompt();
        const { outcome } = await deferredPrompt.userChoice;
        if (outcome === "accepted") {
            setShowBanner(false);
        }
        setDeferredPrompt(null);
    };

    const handleDismiss = () => {
        setShowBanner(false);
        setShowIOSGuide(false);
        localStorage.setItem("pwa-banner-dismissed", "1");
    };

    if (!showBanner) return null;

    // ── iOS Guide ─────────────────────────────────────────────
    if (isIOS) {
        return (
            <div style={{
                position: "fixed", bottom: 0, left: 0, right: 0, zIndex: 9999,
                background: "white", borderRadius: "20px 20px 0 0",
                boxShadow: "0 -8px 32px rgba(0,0,0,.15)",
                padding: "20px 20px 32px", direction: "rtl",
                fontFamily: "'Segoe UI', system-ui, sans-serif",
                animation: "slideUp .3s ease",
            }}>
                {/* Handle */}
                <div style={{ width: 40, height: 4, borderRadius: 2, background: "#E2E8F0", margin: "0 auto 16px" }} />

                <div style={{ display: "flex", alignItems: "center", gap: 12, marginBottom: 16 }}>
                    <div style={{ width: 48, height: 48, borderRadius: 12, background: "linear-gradient(135deg,#F97316,#EA580C)", display: "flex", alignItems: "center", justifyContent: "center", fontSize: 24, flexShrink: 0 }}>🚗</div>
                    <div>
                        <div style={{ fontWeight: 800, fontSize: 16 }}>ثبّت تطبيق رايدو</div>
                        <div style={{ fontSize: 13, color: T.muted }}>للوصول السريع من الشاشة الرئيسية</div>
                    </div>
                    <button onClick={handleDismiss} style={{ marginRight: "auto", background: "none", border: "none", color: T.muted, cursor: "pointer", fontSize: 20, padding: 4 }}>✕</button>
                </div>

                <div style={{ background: "#F8FAFC", borderRadius: 14, padding: "14px 16px" }}>
                    <div style={{ fontSize: 13, color: T.muted, marginBottom: 12, fontWeight: 600 }}>
                        اتبع الخطوات التالية:
                    </div>
                    {[
                        { n: "١", icon: "⬆️", text: 'اضغط على زر "مشاركة" في الأسفل' },
                        { n: "٢", icon: "➕", text: 'اختر "إضافة للشاشة الرئيسية"' },
                        { n: "٣", icon: "✅", text: 'اضغط "إضافة" للتأكيد' },
                    ].map(s => (
                        <div key={s.n} style={{ display: "flex", alignItems: "center", gap: 10, marginBottom: 10 }}>
                            <div style={{ width: 28, height: 28, borderRadius: "50%", background: T.accent, color: "white", display: "flex", alignItems: "center", justifyContent: "center", fontSize: 12, fontWeight: 800, flexShrink: 0 }}>{s.n}</div>
                            <span style={{ fontSize: 14 }}>{s.icon} {s.text}</span>
                        </div>
                    ))}
                </div>
            </div>
        );
    }

    // ── Android/Chrome Banner ─────────────────────────────────
    return (
        <div style={{
            position: "fixed", bottom: 16, left: 16, right: 16, zIndex: 9999,
            background: "white", borderRadius: 16,
            boxShadow: "0 8px 32px rgba(0,0,0,.15)",
            padding: "14px 16px", direction: "rtl",
            fontFamily: "'Segoe UI', system-ui, sans-serif",
            display: "flex", alignItems: "center", gap: 12,
            animation: "slideUp .3s ease",
        }}>
            <div style={{ width: 44, height: 44, borderRadius: 12, background: "linear-gradient(135deg,#F97316,#EA580C)", display: "flex", alignItems: "center", justifyContent: "center", fontSize: 22, flexShrink: 0 }}>🚗</div>

            <div style={{ flex: 1, minWidth: 0 }}>
                <div style={{ fontWeight: 700, fontSize: 14 }}>ثبّت تطبيق رايدو</div>
                <div style={{ fontSize: 12, color: T.muted }}>   اضغط على تثبيت لتحميل التطبيق على موبايلك</div>
            </div>

            <button
                onClick={handleInstall}
                style={{ padding: "8px 16px", borderRadius: 10, border: "none", background: "linear-gradient(135deg,#F97316,#EA580C)", color: "white", fontFamily: "inherit", fontSize: 13, fontWeight: 700, cursor: "pointer", flexShrink: 0 }}
            >
                تثبيت
            </button>

            <button onClick={handleDismiss} style={{ background: "none", border: "none", color: T.muted, cursor: "pointer", fontSize: 18, padding: 4, flexShrink: 0 }}>✕</button>
        </div>
    );
}